import {atom, selector} from 'recoil';
import {authState} from '../../../store/auth/atoms';
import {getCurrentCompany} from '../helpers/get-current-company';

export const companyTariffRefreshState = atom({
  key: 'companyTariffRefresh',
  default: 0,
});

export const companyTariffRestrictionState = atom<string | null>({
  key: 'companyTariffRestriction',
  default: null,
});

export const currentCompanyTariffQuery = selector({
  key: 'currentCompanyTariff',
  get: ({get}) => {
    get(companyTariffRefreshState);
    const {user} = get(authState);
    return user?.companyId ? getCurrentCompany(user.companyId) : null;
  },
  cachePolicy_UNSTABLE: {eviction: 'most-recent'},
});
